export const NamingUtils = {
 getSentimentType: (SentimentType: string) => {
  switch (SentimentType) {
   case 'Positive':
    return 'p'
    break
   case 'Neutral':
    return 'n'
    break
   case 'Negative':
    return 'v'
    break
   case 'Not Rated':
    return 'u'
    break
   default:
    break
  }
 },
 buildSentimentChartData: data => {
  return data.map(x => {
   switch (x.key) {
    case 'p':
     x.key = 'Positive'
     break
    case 'n':
     x.key = 'Neutral'
     break
    case 'v':
     x.key = 'Negative'
     break
    case 'u':
     x.key = 'Not Rated'
     break
    default:
     break
   }
   return x
  })
 },

 getGenderType(data: any) {
  return data.map(x => {
   switch (x.key) {
    case 'f':
     x.key = 'Female'
     break
    case 'm':
     x.key = 'Male'
     break
    case 'u':
     x.key = 'Unknown'
     break
    default:
     break
   }
   return x
  })
 },

 getCountryCode: (key, data) => {
  return data.find(x => x.key === key).code
 },

 prettyNames: data => {
  switch (data) {
   case 'p':
    data = 'Positive'
    break
   case 'n':
    data = 'Neutral'
    break
   case 'v':
    data = 'Negative'
    break
   case 'u':
    data = 'Not Rated'
    break
   default:
    break
  }
  return data
 },
 returnData: obj => Object.keys(obj).map(key => ({ key, value: obj[key] })),
}
